import { getPaymentTypeOrPayeeType } from '../modes/selectors';
import { TYPE_FASTER_PAYMENTS, TYPE_CHAPS, TYPE_IFT, TYPE_BACS_CREDIT, TYPE_BACS_DEBIT } from '../../config';
import { pages } from './actions';

export const getPage = (state) => {
	const {
		page: { name = '' },
	} = state;
	return name.split('/')[0];
};
export const getSubPage = (state) => {
	const {
		page: { name = '' },
	} = state;
	return name.split('/')[1];
};
export const getPrevious = (state) => state.page.previousPage;
export const hasError = (state) => state.page.hasError;
export const hasReadTimeOutError = (state) => !!state.page.hasReadTimeOutError;

// FIXME: Clean decideBackPageForPayeePicker and getPayeePickerBackPage while router refactor.
const decideBackPageForPayeePicker = (state, accountPickerPage, landingPage) => {
	const previousPage = getPrevious(state);
	if (previousPage.includes(accountPickerPage)) {
		return landingPage;
	}
	return previousPage;
};
export const getPayeePickerBackPage = (state) => {
	const paymentType = getPaymentTypeOrPayeeType(state);
	switch (paymentType) {
		case TYPE_FASTER_PAYMENTS:
			return decideBackPageForPayeePicker(state, pages.FasterPaymentsAccountPicker, pages.FasterPaymentsLandingPage);
		case TYPE_CHAPS:
			return decideBackPageForPayeePicker(state, pages.ChapsAccountPicker, pages.ChapsLandingPage);
		case TYPE_IFT:
			return decideBackPageForPayeePicker(state, pages.IFTAccountPicker, pages.IFTLandingPage);
		case TYPE_BACS_CREDIT:
			return decideBackPageForPayeePicker(state, pages.BacsCreditAccountPicker, pages.BacsCreditLanding);
		case TYPE_BACS_DEBIT:
			return decideBackPageForPayeePicker(state, pages.BacsDebitAccountPicker, pages.BacsDebitLanding);
		default:
			return '';
	}
};
